import script from "./KDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./KDialog.vue?vue&type=script&setup=true&lang=ts"

import "./KDialog.vue?vue&type=style&index=0&id=20e3bb18&lang=sass&scoped=true"
import "./KDialog.vue?vue&type=style&index=1&id=20e3bb18&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e3bb18"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
